import { combineReducers } from 'redux'

import mediaPlanner from './mediaPlanner'

export default combineReducers({
  mediaPlanner,
})
